import React, { memo } from "react"
import types from "prop-types"
import clsx from "clsx"
import ActivityIndicator from "shared/ActivityIndicator"

const LoadingIndicator = ({ className = "", textValue = "Loading ..." }) => (
  <div className={clsx(className, "flex flex-col w-full items-center pt-2")}>
    <ActivityIndicator className="mb-4" />
    <span>{textValue}</span>
  </div>
)

LoadingIndicator.propTypes = {
  className: types.string,
  textValue: types.string,
}

export default memo(LoadingIndicator)
